export default {
  FETCH_MARKETPLACES_REQUEST: 'FETCH_MARKETPLACES_REQUEST',
  FETCH_MARKETPLACES_SUCCESS: 'FETCH_MARKETPLACES_SUCCESS',
  FETCH_MARKETPLACES_FAILURE: 'FETCH_MARKETPLACES_FAILURE',
  UPDATE_MARKETPLACES_FILTERS: 'UPDATE_MARKETPLACES_FILTERS',
  RESET_MARKETPLACES: 'RESET_MARKETPLACES'
}
